export default "__VITE_ASSET__BfEXU22F__"